import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import TextInput from "../../components/input/TextInput";
import { Box, Grid, Typography } from "@mui/material";
import { getBase64FileModel } from "../Helper/FileToBase64";
import DeletePhotoButton from "../../components/buttons/DeletePhotoButton";
import UploadedImageDisplay from "../../components/display/UploadedImageDisplay";
import ThumbnailPhotoInput from "../../components/input/ImageInput";
import SelectOption from "../../components/input/SelectOption";
import { AddProductValidationSchema } from "../Validations/ValidationSchemas";
import SubmitButton from "../../components/buttons/SubmitButton";
import { getBranchOptionsHttp, getCategoryOptionsByBranchHttp, getSubcategoryOptionsHttp } from "../../services/OptionService";
import { createProductHttp, getProductHttp, updateProductHttp } from "../../services/ProductService";
import { useNavigate } from "react-router-dom";

const productSchema = {
  id:"",
  name: "",
  description: "",
  price:"",
  thumbnailPhoto: "",
  categoryId: null,
  subCategoryId: null,
  branchId: null,
};

const categories = [
  { text: "Ana Yemek", value:1},
  { text: "Tatlı", value:2},
  { text: "Meşrubat", value:3}
]

const subcategories = [
  { text: "Ana Yemek", value:1},
  { text: "Tatlı", value:2},
  { text: "Meşrubat", value:3}
]

function AddProduct({id}) {
  const [branchOptions, setBranchOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([])
  const [subcategoryOptions, setSubcategoryOptions] = useState([])
  const navigateTo = useNavigate();

  const handleSubmit = (values) => {
    values.price = parseFloat(values.price.toString().replace(",", "."))
    if(id) updateProductHttp(values).finally(()=>navigateTo("/admin-panel"))
    else createProductHttp(values).finally(()=>navigateTo("/admin-panel"))
  }

  const formik = useFormik({
    initialValues: productSchema,
    validationSchema: AddProductValidationSchema,
    validateOnChange: false,
    validateOnMount: false,
    validateOnBlur: false,
    onSubmit: (values) => handleSubmit(values)
  });

  const handleDeleteThumbnailPhoto = () => {
    formik.setValues((prev) => {
      return { ...prev, thumbnailPhoto: "" };
    });
  };

  const getSubcategoryOptions = (id) =>{
    getSubcategoryOptionsHttp(id).then((resp)=>{
      setSubcategoryOptions(resp.data)
    })
  }

  const getCategoryOptions = (branchId) => {
    getCategoryOptionsByBranchHttp(branchId).then((resp)=>{
      setCategoryOptions(resp.data)
    })
  }

  useEffect(()=>{
    getBranchOptionsHttp().then((resp)=>setBranchOptions(resp.data))
    if(id){
      getProductHttp(id).then((resp)=>{
        formik.setValues(
          {
            id: resp.data.id,
            name: resp.data.name,
            description: resp.data.description,
            thumbnailPhoto: resp.data.thumbnailPhoto,
            price:resp.data.price,
            branchId:resp.data.category.branchId,
            categoryId: resp.data.categoryId,
            subCategoryId: resp.data.subCategoryId || null,
          }
        )
        getCategoryOptions(resp.data.category.branchId)
      })
    }
  },[id])

  useEffect(() => {
    if(formik.values.categoryId)
      getSubcategoryOptions(formik.values.categoryId)
  }, [formik.values.categoryId])

  return (
    <form>
    <Box marginX={1}>
    {/* <pre>{JSON.stringify(formik.values,null,2)}</pre> */}
      <Typography variant="h6" marginBottom={1}>
        Ürün Kapak Fotoğrafı
      </Typography>
    </Box>
    <SelectOption
      label="Şube"
      name="branchId"
      options={branchOptions} 
      value={formik.values.branchId}
      onChange={(e)=>{
        getCategoryOptions(e.target.value);
        formik.handleChange(e);
      }}
    />
    <SelectOption
      label="Kategori"
      options={categoryOptions}
      disabled={!categoryOptions.length>0}
      value={formik.values.categoryId}
      onChange={(e) => {
        formik.setValues((prev) => {
          return {
            ...prev,
            categoryId: e.target.value,
          };
        });
      }}
    />
    <SelectOption
      label="Alt Kategori"
      options={subcategoryOptions}
      disabled={!subcategoryOptions.length>0}
      value={formik.values.subCategoryId}
      onChange={(e) => {
        formik.setValues((prev) => {
          return {
            ...prev,
            subCategoryId: e.target.value,
          };
        });
      }}
    />
      {/* <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} position="relative" paddingX={1} paddingY={0}>
          <ThumbnailPhotoInput
            hidden={formik.values.thumbnailPhoto}
            onChange={async (e) =>
              await getBase64FileModel(e.target.files[0]).then((resp) =>
                formik.setValues((prev) => {
                  return {
                    ...prev,
                    thumbnailPhoto: resp.file,
                  };
                })
              )
            }
          />
          <DeletePhotoButton
            marginRight={1}
            onClick={handleDeleteThumbnailPhoto}
            hidden={!formik.values.thumbnailPhoto}
          />
          <UploadedImageDisplay src={formik.values.thumbnailPhoto} />
        </Grid>
      </Grid> */}
      <TextInput name="thumbnailPhoto" value={formik.values.thumbnailPhoto}  onChange={formik.handleChange} label="Fotoğraf Linki" />
      <TextInput name="name" value={formik.values.name}  onChange={formik.handleChange} label="Ürün Adı" />
      <TextInput name="description" value={formik.values.description}  onChange={formik.handleChange} label="Açıklama" />
      <TextInput name="price" value={formik.values.price}  onChange={formik.handleChange} label="Fiyat" />
      <SubmitButton onClick={formik.handleSubmit} />
      {/* <pre>{JSON.stringify(formik.values, null, 2)}</pre> */}
    </form>
  );
}

export default AddProduct